var map = {
	"./ShowPeice1Back.webp": 9023,
	"./ShowPeice1Front.webp": 1155,
	"./ShowPeice2Back.webp": 1990,
	"./ShowPeice2Front.webp": 448,
	"./ShowPeice3Back.webp": 1541,
	"./ShowPeice3Front.webp": 3497,
	"./ShowPeice4Back.webp": 4764,
	"./ShowPeice4Front.webp": 358,
	"./ShowPeice5Back.webp": 6403,
	"./ShowPeice5Front.webp": 4607,
	"./ShowPeice6Back.webp": 3498,
	"./ShowPeice6Front.webp": 4524,
	"./ShowPeice7Back.webp": 6073,
	"./ShowPeice7Front.webp": 1013,
	"./ShowPeice8Back.webp": 8160,
	"./ShowPeice8Front.webp": 9650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9573;